import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import { useMemo } from 'react'

const TrendTable = ({ dataList, options }) => {
  const tableRowsData = useMemo(() => {
    if (!Array.isArray(dataList) || !Array.isArray(options)) return []
    // 对List进行遍历，对column按照Options进行顺序
    return (
      dataList.map((item, idx) => ({
        rowKey: `row-${item.key || idx}`,
        rowData: options.map(row => {
          // 列数据
          const { dataIndex, render } = row
          if (render) {
            return { cellKey: `cell-${dataIndex}-${idx}`, cellData: render(item) }
          }
          return { cellKey: `cell-${dataIndex}-${idx}`, cellData: item[dataIndex] }
        })
      })) || []
    )
  }, [dataList, options])

  return (
    <TableContainer className="border border-[#E0E2EF] rounded-2xl overflow-hidden">
      <Table aria-label="simple table">
        <TableHead>
          <TableRow className="bg-[rgba(211,221,204,0.5)]">
            {options.map(({ title }) => (
              <TableCell
                key={title}
                className="text-xs lg:text-base font-semibold py-3 px-3 lg:px-6"
              >
                {title}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {tableRowsData.map(({ rowKey, rowData }) => (
            <TableRow key={rowKey} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
              {rowData.map(({ cellKey, cellData }) => (
                <TableCell
                  key={cellKey}
                  className="lg:text-base text-xs"
                  classes={{ body: 'px-3 lg:px-6' }}
                >
                  {cellData}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default TrendTable
